"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _reactI18next = require("react-i18next");

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _EditOutlined = _interopRequireDefault(require("@material-ui/icons/EditOutlined"));

var _Route = require("../../provider/Route");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:VerticalChange';
var verticalNs = 'pc-matching:Vertical';

var VerticalChange = function VerticalChange(_ref) {
  var current = _ref.current;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext.routeInternal;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "h4",
        component: "h4",
        align: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.firstSubtitle,
          children: t("".concat(translateNs, ".title"))
        })
      })
    }, "verticalChange"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
      className: _styleModule.default.divider
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 1,
      justify: "space-between",
      alignItems: "center",
      className: "".concat(_styleModule.default.line, " ").concat(_styleModule.default.set),
      onClick: function onClick() {
        return routeInternal('vertical');
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckCircle.default, {
          className: "".concat(_styleModule.default.icon)
        })
      }, "verticalChangeIcon"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 9,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
          component: "p",
          align: "left",
          className: _styleModule.default.text,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.editElementLabel,
            children: t("".concat(translateNs, ".label"))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.editElement,
            children: t("".concat(verticalNs, ".").concat(current || ''))
          })]
        })
      }, "verticalChangeGridDisplay"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          "aria-label": "edit",
          size: "small",
          className: "".concat(_styleModule.default.editIcon),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditOutlined.default, {})
        })
      }, "verticalChangeGridEdit")]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
      className: _styleModule.default.divider
    })]
  });
};

var _default = VerticalChange;
exports.default = _default;